<template>
  <el-tag :type="getStatusItem(status).type" size="mini" class="text-uppercase">
    {{ $t(getStatusItem(status).translationKey) }}
  </el-tag>
</template>

<script>
import REQUEST_STATUS from '../../js/constants/request-status';

export default {
  name: 'StatusTag',
  components: {},
  props: {
    status: {
      type: String,
      default: '',
    },
  },
  mounted() {},
  destroyed() {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    getStatusItem(status) {
      return REQUEST_STATUS.filter((el) => el.value === status)[0];
    },
  },
};
</script>

<style scoped></style>
